"use client";
import React, {forwardRef, useImperativeHandle, useState, useRef} from "react";

export type InputProps = {
    value?: string;
    type?: "text" | "password" | "number" | "email" | "url" | "tel";
    placeholder?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    extra?: React.ReactNode;
}

export type InputRef = {
    setValue: (val: string) => void;
    getValue: () => void;
    focus: () => void;
}

const Input = forwardRef<InputRef, InputProps>((props, ref) => {
    const {
        value,
        type,
        placeholder,
        onChange,
        onBlur,
        extra,
    } = props;

    const [refValue, setRefValue] = useState('')
    const myRef = useRef<HTMLInputElement>(null)

    useImperativeHandle(
        ref,
        () => {
            return {
                setValue: (val) => {
                    if (myRef.current) {
                        myRef.current.value = val;
                        console.log(val)
                    }
                },
                getValue: () => {
                    return myRef.current?.value;
                },
                focus: () => {
                    if (myRef.current) {
                        myRef.current.focus();
                    }
                }
            }
        }
    )

    return (
        <div style={{position: "relative"}}>
            <input
                style={{
                    width: "100%",
                }}
                ref={myRef}
                value={value}
                type={type}
                placeholder={placeholder}
                onChange={onChange}
                onBlur={onBlur}
            />
            {extra}
        </div>
    )
})

export default Input;